import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpSentEvent, HttpUserEvent, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable, InjectionToken, Inject } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { finalize, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AUTH_REDIRECT_PAGE } from '@pcplus/domain-core';
import { Message, PubsubService } from '@pcplus/core';
// import { AuthenticationService } from '../services/authentication/authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    @Inject(AUTH_REDIRECT_PAGE) private authRedirectPage: string,
    private pubsub: PubsubService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // REMOVED BEARER AUTH IN FAVOR OF HTTP-ONLY COOKIE ACCESS AND REFRESH TOKENS
    // // Get the auth token from the service.
    // const user = localStorage.getItem('currentUser');
    // let accessToken = '';
    // if (user) {
    //   accessToken = JSON.parse(user).token;
    // }
    // let headers = req.headers.set('Authorization', 'Bearer ' + accessToken);

    let headers = req.headers;
    if (req.method !== 'GET' && !req.reportProgress) {
      headers = headers.set('Content-Type', 'application/json');
    }

    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    const authReq = req.clone({
      headers,
      withCredentials: true
    });
    this.pubsub.publish(new Message('InterceptingHttpRequest', null));
    let unauthorized = false;
    // send cloned request with header to the next handler.
    return next.handle(authReq).pipe(
      tap({
        error: (error) => {
          if (error instanceof HttpErrorResponse) {            
            const innerMessage =
              (error.error as any)?.Message
                ? (error.error as any).Message
                : (error.error as any)?.title
                ? (error.error as any).title
                : error.message
                ? error.message
                : '';
            if (
              error.status === 401 &&
              !innerMessage.includes('The operation was not authorized.')
            ) {
              console.log('unauthorized ' + error.message);
              unauthorized = true;
            }
          }
        }
      }),
      finalize(() => {
        if (unauthorized) {
          localStorage.removeItem('currentUser');
          const navigationExtras: NavigationExtras = {
            queryParamsHandling: 'preserve',
            preserveFragment: true
          };
          this.router.navigate([this.authRedirectPage], navigationExtras);
        }
      })
    );
  }
}
